export const MODAL_CONFIG = {
    freeModConfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'freeModal',
        arialabelledby:"General Popup"
    },
    paymentconfig: {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: true,
        class: 'enroll-modal payment-modal',
        arialabelledby:"Paypal Payment"
    },
    viewdetailsconfig: {
        animated: true,
        keyboard: true,
        backdrop: false,
        ignoreBackdropClick: true,
        class: 'viewDetailsModal',
        arialabelledby:"View Details"
    },
    errormodalconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'childmodal successmodal',
        arialabelledby:"Error Message!!!"
    },
    signinconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'signin-modal',
        arialabelledby:"Sign In"
    },
    successmodalconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'childmodal successmodal',
        arialabelledby:"Sucesss"
    },
    forgotconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: "forgotmodal childmodal",
        arialabelledby:"Forgot Password"
    },
    contactconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'contact-modal',
        arialabelledby:"Contact Us"
    },
    termsConfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: false,
        class: 'terms-modal',
        ariaLabelledBy:"terms-of-use",
        arialabelledby:"Terms of use",
        '[attr.aria-labelledby]': 'terms-of-use'
    },
    policyConfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: false,
        class: 'terms-modal',
        '[attr.aria-labelledby]': 'privacy-feeling'
    },
    slaConfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: false,
        class: 'terms-modal',
        ariaLabelledBy:"service-level-agreements",
        arialabelledby:"Service Level Agreements"
    },
    profileconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'profile-modal',
        arialabelledby:"Profile"
    },
    certificateconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'certificate-modal',
        arialabelledby:"Certificate"
    },
    editprofileconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'childmodal editprofile',
        arialabelledby:"Edit Profile"
    },
    changepasswordconfig: {
        animated: true,
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'childmodal changepassword',
        arialabelledby:"Change Password"
    }
};



// WEBPACK FOOTER //
// ./src/app/shared/constant/modalConfig.constant.ts